import { __rest } from 'tslib';
import React, { forwardRef } from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import { Root } from './styled.js';

const Link = forwardRef((_a, ref) => {
    var { underline = false, before, after, size = 'medium', textAlign, uppercase, children, className, whiteSpace } = _a, props = __rest(_a, ["underline", "before", "after", "size", "textAlign", "uppercase", "children", "className", "whiteSpace"]);
    const _underline = props.disabled === true ? false : underline;
    const theme = useTheme();
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-link' }, props, { ref: ref, "$theme": theme, "$size": size, "$disabled": props.disabled, "$textAlign": textAlign, "$whiteSpace": whiteSpace, "$uppercase": uppercase, underline: _underline, className: ['tend-ui-typography-link', className].filter(Boolean).join(' ') }),
        before,
        children,
        after));
});
Link.displayName = 'Link';

export { Link };
//# sourceMappingURL=Link.js.map
